import { useContext } from "react";
import { motion } from "framer-motion";
import { LanguageContext } from "../App";

export default function Trust() {
  const { t } = useContext(LanguageContext);
  const tr = t.trust;

  return (
    <section
      id="trust"
      data-testid="trust-section"
      className="bg-[#F5F1EA] py-24 md:py-32 px-6"
    >
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-16 text-center max-w-2xl mx-auto">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
            className="font-['Manrope',sans-serif] text-xs uppercase tracking-[0.3em] text-[#7B907F] mb-4"
            data-testid="trust-overline"
          >
            {tr.overline}
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 25 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: 0.1 }}
            className="font-['Cormorant_Garamond',serif] text-2xl sm:text-3xl md:text-4xl md:text-5xl font-light text-[#2A2726] tracking-tight mb-5"
            data-testid="trust-headline"
          >
            {tr.headline}
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="font-['Manrope',sans-serif] text-base text-[#5C5754] leading-relaxed"
            data-testid="trust-text"
          >
            {tr.text}
          </motion.p>
        </div>

        {/* Trust phrases */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#DDD8CE]">
          {tr.phrases.map((phrase, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.12 }}
              className="bg-[#F5F1EA] px-6 py-10 md:px-10 md:py-12 text-center flex flex-col items-center gap-4"
              data-testid={`trust-phrase-${i}`}
            >
              <div className="w-8 h-px bg-[#7B907F]" />
              <p className="font-['Cormorant_Garamond',serif] text-xl md:text-2xl font-light text-[#2A2726] leading-snug italic">
                "{phrase}"
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
